import _implicitStylesheets from "./inputCheckbox.css";
import _implicitScopedStylesheets from "./inputCheckbox.scoped.css?scoped=true";
import _i18nLink from "i18n/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="showError${0}"${2}>${"t1"}</div>`;
const stc0 = {
  classMap: {
    "checkbox-container": true
  },
  attrs: {
    "grid": ""
  },
  key: 1
};
const stc1 = {
  classMap: {
    "slot": true,
    "left": true
  },
  key: 2
};
const stc2 = {
  attrs: {
    "name": "left"
  },
  key: 3
};
const stc3 = [];
const stc4 = {
  attrs: {
    "name": "left"
  },
  key: 4
};
const stc5 = {
  "inputCheckbox": true
};
const stc6 = {
  "checkbox-text": true
};
const stc7 = {
  attrs: {
    "name": "label"
  },
  key: 8
};
const stc8 = {
  classMap: {
    "slot": true,
    "right": true
  },
  key: 9
};
const stc9 = {
  attrs: {
    "name": "right"
  },
  key: 10
};
const stc10 = {
  attrs: {
    "name": "right"
  },
  key: 11
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, b: api_bind, s: api_slot, h: api_element, gid: api_scoped_id, ti: api_tab_index, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.stateClassName),
    key: 0,
    on: {
      "slotchange": _m0 || ($ctx._m0 = api_bind($cmp.handleSlotChange))
    }
  }, [api_element("div", stc0, [$cmp.hasSlots.left ? api_element("div", stc1, [api_slot("left", stc2, stc3, $slotset)]) : null, !$cmp.hasSlots.left ? api_slot("left", stc4, stc3, $slotset) : null, api_element("input", {
    classMap: stc5,
    attrs: {
      "id": api_scoped_id("field"),
      "type": "checkbox",
      "name": $cmp.name,
      "tabindex": api_tab_index($cmp.tabIndex),
      "disabled": $cmp.disabled ? "" : null,
      "aria-label": $cmp.ariaLabel
    },
    props: {
      "value": $cmp.value,
      "checked": $cmp.checked
    },
    key: 5,
    on: {
      "change": _m1 || ($ctx._m1 = api_bind($cmp.handleCheckboxChange)),
      "focus": _m2 || ($ctx._m2 = api_bind($cmp.handleFocus)),
      "blur": _m3 || ($ctx._m3 = api_bind($cmp.handleBlur))
    }
  }), api_element("label", {
    classMap: stc6,
    attrs: {
      "for": api_scoped_id("field")
    },
    key: 6
  }, [$cmp.label ? api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.label,
      "target": "_blank"
    },
    key: 7
  }) : null, api_slot("label", stc7, stc3, $slotset)]), $cmp.hasSlots.right ? api_element("div", stc8, [api_slot("right", stc9, stc3, $slotset)]) : null, !$cmp.hasSlots.right ? api_slot("right", stc10, stc3, $slotset) : null])]), $cmp._errorMessage ? api_static_fragment($fragment1, 13, [api_static_part(1, null, api_dynamic_text($cmp._errorMessage))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["label", "left", "right"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-h0kkig83eh";
tmpl.legacyStylesheetToken = "undefined-_inputCheckbox";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
